//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/departmentListTemplate.html"], function (
  Marionette,
  DepartmentListTemplate,
) {
  "use strict";

  var DepartmentListView = {};

  DepartmentListView.departmentListLayout = Marionette.Layout.extend({
    template: DepartmentListTemplate,
    regions: {
      departmentList: "#departmentList",
    },
    triggers: {
      "click #addDepartment": "add:department",
    },
  });

  return DepartmentListView;
});
